
import { FilePdfOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'
import { useParams } from 'react-router-dom'
import { URL_RESULTADO_CARRERA } from '../../api/url'
import ReporteGeneral from '../../components/ReporteGeneral'
import useReporteResultadoExamenCarrera from '../../hooks/adminexamen/useReporteResultadoExamenCarrera'
import { useLoginStore } from '../../stores/useLoginStore'

const ReporteCarrera = () => {

  const objLogueado = useLoginStore( store => store.objLogueado)

  const { id } = useParams()
  const { traerReporte } = useReporteResultadoExamenCarrera()

  var { carrera } = objLogueado.carreras.find( e => {
    return e.pk_carrera === id
  })

  return (
    <>

      <a className='link-carrera' onClick={ () => traerReporte( id, carrera )} href="#">
        <Button type="primary" icon={ <FilePdfOutlined /> }>
          Descargar resultados
        </Button>
      </a>

      <ReporteGeneral pk_carrera={ id }/>
        
    </>
  )
}

export default ReporteCarrera
